import React from 'react'
import {Drawer} from 'antd'
import MenuLeft from './MenuLeft'
import MenuTop from './MenuTop'
import { useAppDispatch, useAppSelector } from '../../../ducks/hooks'
import { setLayoutState } from '../../../ducks/app'
import './style.scss'

interface AppMenuProps {
  isMobile: boolean;
}

const AppMenu: React.FC<AppMenuProps> = ({ isMobile }) => {
  const dispatch = useAppDispatch();
  const isMenuTop = useAppSelector(state => state.app.layoutState.isMenuTop);
  const open = useAppSelector(state => state.app.layoutState.menuMobileOpened);
  const toggleOpen = () => {
    dispatch(setLayoutState({ menuMobileOpened: !open }));
  }

  return isMobile ? (
    <Drawer
      placement="left"
      open={open}
      onClose={toggleOpen}
    >
      <MenuLeft isMobile={isMobile} />
      {/*<ProfileMenu />*/}
    </Drawer>
  ) : isMenuTop ? (
    <MenuTop isMobile={isMobile} />
  ) : (
    <MenuLeft isMobile={isMobile} />
  );
}

export default AppMenu
